module.exports = __webpack_public_path__ + "img/25.4c0746ed.png";